import { faSave } from "@fortawesome/free-solid-svg-icons";
import { useModalControls } from "@hostingbv/lib/src/components/layout/ModalProvider";
import { FC, useCallback, useState } from "react";
import { config } from "../config";
import { useApiClient } from "@hostingbv/lib/src/api";
import { useRefresh } from "../../../lib/src/components/RefreshController";
import { useRealtimeDeployments } from "../components/deployments/RealtimeDeployments";
import { MailDomain } from "../../../lib/src/api/partner/models/MailDomain";
import { Button, Input } from "@ventumsoftware/react-toolkit";


export const AddTransactionalMailAliasModal: FC<{ domain: MailDomain }> = ({ domain }) => {
  const { partnerClient } = useApiClient(config)
  const { awaitNextDeploymentFinished } = useRealtimeDeployments()!
  const refresh = useRefresh()
  const { close } = useModalControls()
  const [aliasDomain, setAliasDomain] = useState('')
  const [error, setError] = useState('')
  const [isSaving, setIsSaving] = useState(false)

  const save = useCallback(async () => {
    setIsSaving(true)
    try {
      const result = await partnerClient.addAliasToTransactionalMailDomain(domain.id, aliasDomain.trim())
      if (!result.success) {
        setError(result.error)
        return
      }
      await awaitNextDeploymentFinished(result.data.id)
      refresh()
      close()
    } finally {
      setIsSaving(false)
    }
  }, [domain, aliasDomain])

  return <>
    <form onSubmit={(e) => { e.preventDefault(); save() }} className={"space-y-4 flex-1"}>
      <Input label={'Alias domain'} type={"text"} value={aliasDomain} onChange={setAliasDomain} />
      {error.length > 0 && <div className={"font-medium text-red-600"}>
        {error}
      </div>}
    </form>
    <footer className={"-mx-4 px-4 mt-3 py-3 border-t border-slate-100 flex items-center space-x-4"}>
      <Button type={'primary'} disabled={isSaving || aliasDomain.trim().length === 0} size={'md'} icon={faSave} text={isSaving ? 'Saving...' : 'Add'} onClick={save} />
      <Button type={'secondary'} size={'md'} text={'Cancel'} onClick={() => close()} />
    </footer>
  </>
}
